"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _activityCreationApi = require("@/api/activityCreationApi");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dialogVisible: false,
      conditionType: {},
      // 条件
      // timeArray: '',
      ruleForm: {
        name: '',
        // 活动名称
        jumpType: 1,
        // 活动类型
        type: 0,
        // 链接类型
        unionIds: '',
        // 数字id或者链接
        unionCode: '',
        // 平台类型
        colorValue: '',
        // 背景色
        mainImage: '',
        // 头图
        promoteDesc: '',
        // 推广文案
        startTime: '',
        // 活动开始时间
        endTime: '',
        // 活动结束时间
        timeArray: [],
        id: '' // 编辑回传
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        // jumpType: [
        //   { required: true, message: '请选择活动资源', trigger: 'change' }
        // ],
        type: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }],
        // colorValue: [
        //   { required: true, message: '请输入背景色值', trigger: 'blur' },
        //   { min: 0, max: 99, message: '长度在 0 到 99 个字符', trigger: 'blur' }
        // ],
        unionIds: [{
          required: true,
          message: '请输入活动ID/URL',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99999,
          message: '长度在 0 到 99999 个字符',
          trigger: 'blur'
        }],
        unionCode: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        mainImage: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请上传图片',
          trigger: 'blur'
        }]
        // promoteDesc: [
        //   { required: true, message: '请输入推广素材文案', trigger: 'blur' },
        //   { min: 0, max: 1000, message: '长度在 0 到 100 个字符', trigger: 'blur' }
        // ],
        // timeArray: [
        //   { required: true, message: '请选择日期', trigger: 'change' }
        // ]
      },
      addEditor: '' // 新增编辑
    };
  },
  methods: {
    open: function open(data) {
      this.conditionType = data;
      /*
      接收data对象：
      type：add、editor（添加，编辑）
      name：名称
      id：id
      */
      this.title = data.name;
      this.dialogVisible = true;
      this.addEditor = data.type;
      if (data.type === 'editor') {
        console.log('id', data.id);
        this.getActivityApi(data.id);
      } else {
        var end = new Date();
        var start = new Date();
        end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
        start.setHours(0, 0, 0, 0); // 设置为00:00:00
        end.setHours(23, 59, 59, 999); // 设置为23:59:59

        this.ruleForm.timeArray = [this.formatDate(start), this.formatDate(end)];
      }
    },
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    onClose: function onClose() {
      this.resetForm('ruleForm');
      this.dialogVisible = false;
      this.onInitialize();
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.addEditor === 'editor') {
            _this.updateActivityApi();
          } else {
            _this.saveActivityApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 图片上传
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      // this.ruleForm.mainImage = URL.createObjectURL(file.raw)
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              console.log('pictureUrl---------', pictureUrl);
              this.ruleForm.mainImage = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 类型切换
    onRadioGroupChange: function onRadioGroupChange(data) {
      console.log(data);
      this.$refs['ruleForm'].clearValidate();
      // this.onInitialize()
    },
    // 初始化
    onInitialize: function onInitialize() {
      this.ruleForm.appId = null;
      this.ruleForm.name = '';
      this.ruleForm.type = '';
      this.ruleForm.unionIds = '';
      this.ruleForm.unionCode = '';
      this.ruleForm.colorValue = '';
      this.ruleForm.mainImage = '';
      this.ruleForm.promoteDesc = '';
      this.ruleForm.startTime = '';
      this.ruleForm.endTime = '';
      this.ruleForm.timeArray = [];
    },
    // 活动保存
    saveActivityApi: function () {
      var _saveActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm); // 不同类型id赋值
              if (this.ruleForm.type === 0) {
                params.unionActivityId = this.ruleForm.unionIds;
              } else {
                params.unionActivityLink = this.ruleForm.unionIds;
              }
              // 时间数组拆分
              if (this.ruleForm.timeArray == null) {
                params.startTime = null;
                params.endTime = null;
              } else {
                params.startTime = this.ruleForm.timeArray[0];
                params.endTime = this.ruleForm.timeArray[1];
              }
              _context2.n = 1;
              return (0, _activityCreationApi.saveActivityApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.onClose();
                this.$emit('refresh');
                this.$notify.success({
                  title: '温馨提示',
                  message: '新增成功'
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveActivityApi() {
        return _saveActivityApi2.apply(this, arguments);
      }
      return saveActivityApi;
    }(),
    // 活动查询
    getActivityApi: function () {
      var _getActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, data, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                id: id
              };
              _context3.n = 1;
              return (0, _activityCreationApi.getActivityApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                data = res.data;
                this.ruleForm.appId = data.appId;
                this.ruleForm.name = data.name;
                this.ruleForm.type = data.type;
                if (data.type === 0) {
                  this.ruleForm.unionIds = data.unionActivityId;
                } else {
                  this.ruleForm.unionIds = data.unionActivityLink;
                }
                if (data.startTime) {
                  this.ruleForm.timeArray = [data.startTime, data.endTime];
                }
                this.ruleForm.id = data.id;
                this.ruleForm.mainImage = data.mainImage;
                this.ruleForm.jumpType = data.jumpType;
                this.ruleForm.unionCode = data.unionCode;
                this.ruleForm.colorValue = data.colorValue;
                this.ruleForm.promoteDesc = data.promoteDesc;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getActivityApi(_x2) {
        return _getActivityApi2.apply(this, arguments);
      }
      return getActivityApi;
    }(),
    // 编辑
    updateActivityApi: function () {
      var _updateActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm); // 不同类型id赋值
              if (this.ruleForm.type === 0) {
                params.unionActivityId = this.ruleForm.unionIds;
              } else {
                params.unionActivityLink = this.ruleForm.unionIds;
              }
              // 时间数组拆分
              if (this.ruleForm.timeArray == null) {
                params.startTime = null;
                params.endTime = null;
              } else {
                params.startTime = this.ruleForm.timeArray[0];
                params.endTime = this.ruleForm.timeArray[1];
              }
              _context4.n = 1;
              return (0, _activityCreationApi.updateActivityApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$emit('refreshEditor');
                this.onClose();
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateActivityApi() {
        return _updateActivityApi2.apply(this, arguments);
      }
      return updateActivityApi;
    }()
  }
};